import auth from '@/api/auth'
import router from '@/router'


/**
 * 动态添加路由
 * @param {Array} routes - 要添加的路由配置数组
*/
export function addRoutes(routes) {
  routes.forEach(route => {
    router.addRoute(route)
  })
}


/**
 * 过滤异步路由表，返回符合用户权限的路由
 * @param {Array} routes - 异步路由表
 * @returns {Array} 过滤后的路由
 */
export function filterAsyncRoutes(routes) {
    const res = []
    
    routes.forEach(route => {
      const tmp = { ...route }
      
      // 检查路由是否有权限配置
      if (hasPermission(tmp)) {
        // 递归处理子路由
        if (tmp.children) {
          tmp.children = filterAsyncRoutes(tmp.children)
          // 如果处理后子路由不为空，才保留该路由
          if (tmp.children.length > 0) {
            res.push(tmp)
          }
        } else {
          res.push(tmp)
        }
      }
    })
    
    return res
}


/**
 * 检查路由是否有权限
 * @param {Object} route - 路由对象
 */
function hasPermission(route) {
    // 如果路由没有设置权限，则默认有权限
    if (!route.meta || !route.meta.requiresAuth || auth.token) {
      return true
    }
    return false
  }


/**
 * 路由跳转
 * @param {object} route - 路由
 * @param {boolean} [replace=false] - 是否替换当前历史记录
 */
export function navigateTo(route, replace = false) {
    console.log("navigateTo", route)
    if (replace) {
        router.replace({...route})
    } else {
        router.push({...route})
    }
}

/**
 * 返回上一页
 * @param {string|number} [fallback='/'] - 回退失败时的默认路径
*/
export function navigateBack(fallback = '/') {
    if (window.history.state?.back) {
      router.go(-1)
    } else {
      router.push(fallback)
    }
}

/**
 * 获取当前路由查询参数
 * @param {string} key - 参数键名
 * @returns {string|object} - 返回单个参数值或所有参数对象
*/
export function getQuery(key) {
    const route = router.currentRoute.value
    return key ? route.query[key] : { ...route.query }
}


